var _style, _g, _rect, _text;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMiniNoah09(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#9EFF2E;}\n\t.st1{fill:#7CE25A;}\n\t.st2{fill:#231F20;}\n\t.st3{fill:#BE1E2D;}\n\t.st4{fill:#FFDD15;}\n\t.st5{fill:#1B75BB;}\n\t.st6{fill:#009345;}\n\t.st7{fill:#9F1622;}\n\t.st8{fill:#13588E;}\n\t.st9{fill:#006838;}\n\t.st10{fill:#C4AA15;}\n\t.st11{fill:none;}\n\t.st12{fill:#E8D92A;}\n\t.st13{fill:#E12626;}\n\t.st14{fill:#44B449;}\n\t.st15{fill:#3777BC;}\n\t.st16{fill:#45B549;}\n\t.st17{fill:#3677BB;}\n\t.st18{fill:#E8D828;}\n\t.st19{fill:#215584;}\n\t.st20{fill:#21782E;}\n\t.st21{fill:#837F12;}\n\t.st22{fill:#10C685;}\n\t.st23{fill:none;stroke:#FCB01A;stroke-width:6;stroke-miterlimit:10;}\n\t.st24{fill:#A51C3D;}\n\t.st25{fill:#00904C;}\n\t.st26{fill:#702634;}\n\t.st27{fill:#FF1A3B;}\n\t.st28{fill:#FC83B2;}\n\t.st29{fill:#413470;}\n\t.st30{fill:#6C42E2;}\n\t.st31{fill:#B076F4;}\n\t.st32{fill:#0F4417;}\n\t.st33{fill:#BB3A07;}\n\t.st34{fill:#7F2602;}\n\t.st35{fill:#F95B1C;}\n\t.st36{fill:#FFA60D;}\n\t.st37{fill:url(#);}\n\t.st38{fill:url(#SVGID_1_);}\n\t.st39{fill:url(#SVGID_00000073707225692681301730000009815776940961862548_);}\n\t.st40{fill:url(#SVGID_00000052087475365980259340000004502669578285794973_);}\n\t.st41{fill:url(#SVGID_00000139254281110569091300000011669191137354547878_);}\n\t.st42{fill:url(#SVGID_00000145737146933249409420000015891428291334832028_);}\n\t.st43{fill:url(#SVGID_00000103961212552948189920000016154810784167236492_);}\n\t.st44{fill:url(#SVGID_00000104695226436226784400000012285507733003332028_);}\n\t.st45{fill:url(#SVGID_00000077291693914062358890000012205630214899881897_);}\n\t.st46{fill:url(#SVGID_00000012443548413673798670000010473065104329396131_);}\n\t.st47{fill:url(#SVGID_00000061472198559320865990000002309312036010996404_);}\n\t.st48{fill:url(#SVGID_00000099656431304435431860000013727139154294373257_);}\n\t.st49{fill:url(#SVGID_00000003805829973133167850000012667976057568803240_);}\n\t.st50{fill:url(#SVGID_00000089541480083293899770000005262653261140723109_);}\n\t.st51{fill:url(#SVGID_00000016776798882748388020000008480080188901030584_);}\n\t.st52{fill:url(#SVGID_00000129196529339799765160000002946368235991799220_);}\n\t.st53{fill:url(#SVGID_00000094600201028162805150000011420329601228551042_);}\n\t.st54{fill:url(#SVGID_00000127025191519191231110000016887116843304500912_);}\n\t.st55{fill:url(#SVGID_00000047031315161429899470000017970613246709974194_);}\n\t.st56{fill:url(#SVGID_00000008831110634593231630000015839387444507404991_);}\n\t.st57{fill:url(#SVGID_00000022553316035375225140000013918865248584588976_);}\n\t.st58{fill:url(#SVGID_00000151523228557622749050000014213373745560176529_);}\n\t.st59{fill:url(#SVGID_00000052071217295174707070000017810260666153098121_);}\n\t.st60{fill:url(#SVGID_00000076581323818494535920000007954473080090164360_);}\n\t.st61{fill:url(#SVGID_00000013187171946152545960000012752420221900361651_);}\n\t.st62{fill:url(#SVGID_00000062187473472650908960000004166750903654039962_);}\n\t.st63{fill:url(#SVGID_00000080916342115368401000000007002654615660574601_);}\n\t.st64{fill:url(#SVGID_00000067209733575465281580000007796198314354176663_);}\n\t.st65{fill:url(#SVGID_00000179625607281685655030000016017270032395275709_);}\n\t.st66{fill:url(#SVGID_00000179624823701633254090000017984408210823729559_);}\n\t.st67{fill:url(#SVGID_00000076596994628884549950000010607201651557177533_);}\n\t.st68{fill:url(#SVGID_00000124148466704794732820000007690089473001073296_);}\n\t.st69{fill:url(#SVGID_00000075140638583420604150000002289113016747439806_);}\n\t.st70{fill:url(#SVGID_00000070810098416199679470000001814179720049255863_);}\n\t.st71{fill:url(#SVGID_00000152254774985727073240000012723407216281258408_);}\n\t.st72{fill:url(#SVGID_00000083064637209483015520000003259577525068112768_);}\n\t.st73{fill:url(#SVGID_00000181769045339180773930000017279299778919358625_);}\n\t.st74{fill:url(#SVGID_00000119081968121951076780000004761258375056979102_);}\n\t.st75{fill:url(#SVGID_00000070810930173159066290000000700828363217765792_);}\n\t.st76{fill:url(#SVGID_00000017489008411752808950000013669101091861461430_);}\n\t.st77{fill:url(#SVGID_00000002342814120222126200000005300872399555775915_);}\n\t.st78{fill:url(#SVGID_00000182530311813711600160000011241087475439164809_);}\n\t.st79{fill:url(#SVGID_00000039118146194615029730000006876787797856826768_);}\n\t.st80{fill:url(#SVGID_00000007395891928576847770000008189728685070378923_);}\n\t.st81{fill:url(#SVGID_00000027598773333584445860000011995326579815548095_);}\n\t.st82{fill:url(#SVGID_00000061436426571309679780000003552267993594472866_);}\n\t.st83{fill:url(#SVGID_00000005963593049917056570000005785869296053515669_);}\n\t.st84{font-family:'MyriadPro-Regular';}\n\t.st85{font-size:150px;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "463.3,534.8 446.4,606.8 374.5,606.8 357.6,678.8 501.6,678.8 552.1,462.9 408.2,462.9 391.3,534.8  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "392,462.9 341.5,678.8 269.5,678.8 303.2,534.8 231.2,534.8 197.5,678.8 125.5,678.8 176,462.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "874.5,465.1 824,678.8 752,678.8 785.6,537.1 713.7,537.1 764.2,321.2 836.1,321.2 802.5,465.1  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "751.3,606.8 734.5,678.8 518.6,678.8 535.4,606.8 607.4,606.8 624.2,534.8 552.2,534.8 569.1,462.9  713,462.9 679.3,606.8  "
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -941,
    y: -3561.3,
    className: "st11",
    width: 1865.8,
    height: 4469.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -940.9563 -3454.7622)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st84 st85"
  }, "I spent most of my childhood "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 180,
    className: "st84 st85"
  }, "buried in Lego bins. I was ob"), /*#__PURE__*/React.createElement("tspan", {
    x: 1773,
    y: 180,
    className: "st84 st85"
  }, "-"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 360,
    className: "st84 st85"
  }, "sessed with building my own "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 540,
    className: "st84 st85"
  }, "ideas and loved building "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 720,
    className: "st84 st85"
  }, "something from scratch. "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1080,
    className: "st84 st85"
  }, "My logo and branding is "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1260,
    className: "st84 st85"
  }, "heavily inspired by Lego "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1440,
    className: "st84 st85"
  }, "bricks. "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1800,
    className: "st84 st85"
  }, "Like Lego bricks, I wanted my "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1980,
    className: "st84 st85"
  }, "logo to be crafted in multiple "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2160,
    className: "st84 st85"
  }, "of the same piece. "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2520,
    className: "st84 st85"
  }, "I am a very minimalist and "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2700,
    className: "st84 st85"
  }, "bold designer who suffers "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2880,
    className: "st84 st85"
  }, "from design mood swings. "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3060,
    className: "st84 st85"
  }, "My logo is sharp and simple "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3240,
    className: "st84 st85"
  }, "so it can withstand my MANY "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3420,
    className: "st84 st85"
  }, "treatments to it. "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3780,
    className: "st84 st85"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniNoah09);
export default __webpack_public_path__ + "static/media/miniNoah-09.da8710bf7824ab90fbc81e482db42969.svg";
export { ForwardRef as ReactComponent };